import React from 'react';
import CustomButtonWithIcon from "../../../../components/CustomButtonWithIcon/Buttons";
import Icons from "../../../../components/DmpIcons/icons";
import SlidingPanel from "../SlidingPanel";
import HotelListTable from "../../ListTable/HotelsListTable";
import SelectedHotels from "../../Tools/SelectedHotels";

const HotelSelection = ({
                            isOpen, setOpen, selectedHotels, handleRemoveHotel, handleClearAllHotels,
                            handleHotelSelect, hotelRowSelection, setHotelRowSelection,
                            idaccount, jwtToken, showError
                        }) => (
    <div>
        <div className="selected-hotels-view">
            <div className="button-container">
                <CustomButtonWithIcon
                    color="#f9f9f9"
                    hoverColor="#f9f9f9"
                    titleColor="#BAB7b7"
                    hoverTitleColor={"#BAB7b7"}
                    icon={Icons.ActionsIcons.AddIcon}
                    iconSize={"14px"}
                    width={"120px"}
                    height={"24px"}
                    borderRadius="20px"
                    textStyle={{
                        fontFamily: 'Inter',
                        fontSize: '12px',
                        fontWeight: 500,
                        lineHeight: '14.52px',
                        textAlign: 'center',
                    }}
                    onClick={() => setOpen(true)}
                >
          <span style={{ fontSize: "10px", fontFamily: "Inter, sans-serif", fontWeight: 400 }}>
            Add Hotels
          </span>
                </CustomButtonWithIcon>
            </div>
            <div>
                <SelectedHotels
                    selectedHotels={selectedHotels}
                    handleRemoveHotel={handleRemoveHotel}
                    handleClearAllHotels={handleClearAllHotels}
                />
                {showError && (
                    <span style={{ color: '#d32f2f', fontSize: '12px' }}>
            Please select at least one hotel
          </span>
                )}
            </div>
        </div>
        <SlidingPanel size={40} isOpen={isOpen} onClose={() => setOpen(false)}>
            <HotelListTable
                idaccount={idaccount}
                jwtToken={jwtToken}
                onHotelSelect={handleHotelSelect}
                rowSelection={hotelRowSelection}
                setRowSelection={setHotelRowSelection}
                onClose={() => setOpen(false)}
            />
        </SlidingPanel>
    </div>
);

export default HotelSelection;
